import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'form']

  open() {
    this.formTarget.reset()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  disconnect() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }
}
